var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotesClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 445 l0 -45 80 0 80 0 0 45 0 45 -80 0 -80 0 0 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 457 c-2 -7 -3 -107 -2 -222 l3 -210 185 0 185 0 0 220 0 220 -42 3 c-40 3 -43 1 -43 -22 0 -19 5 -26 20 -26 19 0 20 -7 20 -175 l0 -175 -140 0 -140 0 0 175 c0 168 1 175 20 175 15 0 20 7 20 25 0 23 -4 25 -40 25 -24 0 -43 -5 -46 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 300 c0 -6 37 -10 90 -10 53 0 90 4 90 10 0 6 -37 10 -90 10 -53 0 -90 -4 -90 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 240 c0 -6 37 -10 90 -10 53 0 90 4 90 10 0 6 -37 10 -90 10 -53 0 -90 -4 -90 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 180 c0 -6 37 -10 90 -10 53 0 90 4 90 10 0 6 -37 10 -90 10 -53 0 -90 -4 -90 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesClipboard);
export default __webpack_public_path__ + "static/media/notes-clipboard.9b38cc7d3f2a68e233b9552e895fa822.svg";
export { ForwardRef as ReactComponent };